<header class="psh">
    <div class="psh-id">
        <span class="psh-icon" *ngIf="showIcon">
            <ng-content select="[headerIcon]"></ng-content>
        </span>
        <div class="psh-text">
            <h2>{{ title }}</h2>
            <p *ngIf="subtitle">{{ subtitle }}</p>
        </div>
    </div>
    <ng-content select="[headerActions]"></ng-content>
</header>
